import { Component, OnInit, SimpleChanges, OnChanges, ChangeDetectorRef, AfterViewInit, OnDestroy, ChangeDetectionStrategy, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { MyApp } from 'src/app/api/helper/app';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AppConfig } from 'src/app/api/helper/app.config';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { AuftragAnlegenRequest, Auftragstyp, Vertrag, Vertragsposition } from 'src/app/api/model/swagger-model';
import { RemoteService } from 'src/app/api/remote.service';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { SystemService } from 'src/app/api/system.service';

const log = new Logger("VertragPositionenComponent");

@Component({
    selector: 'app-vertrag-positionen',
    templateUrl: './vertrag-positionen.component.html',
    styleUrls: ['./vertrag-positionen.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VertragPositionenComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    static instance: VertragPositionenComponent;

    @Input() vertrag: Vertrag;
    @Input() auftragstyp: Auftragstyp;

    positionen: Vertragsposition[];
    ausgewaehltePositionen: Vertragsposition[] = [];
    isVisible = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private systemService: SystemService,
        private stammdatenService: StammdatenService,
        private auftragService: AuftragService,
        private remoteService: RemoteService,
        private modalController: ModalController,) {

        // VertragDetailsComponent.instance = this;
    }

    ngOnChanges(changes: SimpleChanges) {
        log?.debug('ngOnChanges');
    }

    ngOnDestroy(): void {
        log?.debug('ngOnDestroy');
        this.isVisible = false;
        MyApp.loading(false);
    }

    async ngOnInit() {
        log?.debug('ngOnInit');

        this.isVisible = true;
        
        if (this.vertrag.Positionen.length == 0) {
            await UiHelper.showAlert('Kein Positionen gefunden');
            return;
        }

        this.positionen = this.vertrag.Positionen;
    }

    async ngAfterViewInit() {
        log?.debug('ngAfterViewInit');
    }

    onClose() {
        log?.debug('onClose');
        this.modalController.dismiss(null);
    }

    onVorauswahlPos() {
        log?.debug('onClose');
        this.modalController.dismiss(null);
    }

    onPositionAuswaehlen(position, event) {
      if (event.detail.checked) {
        // Position hinzufügen, falls noch nicht enthalten
        if (!this.ausgewaehltePositionen.includes(position)) {
          this.ausgewaehltePositionen.push(position);
        }
      } else {
        // Position entfernen, wenn Checkbox deaktiviert wird
        this.ausgewaehltePositionen = this.ausgewaehltePositionen.filter(p => p !== position);
      }
    }
  

    async onNeuerAuftrag() {
        log?.debug('onNeuerAuftrag');

        MyApp.loading(true);
        // TODO hier noch die Positionen übergeben, damit es richtig angelget wird
        const positionsString = this.ausgewaehltePositionen.map(p => p.PosNr).join('|');
        
        const request: AuftragAnlegenRequest = {
            Auftragstyp: this.auftragstyp,
            Vertragsnummer: this.vertrag.Vertragsnummer,
            FahrzeugKennzeichen: MyApp.current.getFahrzeugKennzeichen(),
            FahrzeugKey: MyApp.current.getFahrzeugKey(),
            GeraeteNummer: AppConfig.current.geraeteNummer,
            TourKey: '',
            UnterMandant: AppConfig.current.UnterMandant,
            Vertragspositionen: positionsString
        };

        const fahrer = MyApp.current.fahrer.getValue();

        if (fahrer) {
            request.Personalnummer = fahrer.personalnummer;
            request.PersonalKey = fahrer.Key;
            request.PersonalName = fahrer.vorname + ' ' + fahrer.nachname;
        }

        const aktuelleTour = MyApp.current.aktuelleTour.getValue();

        if (aktuelleTour) {
            request.TourKey = aktuelleTour.TourKey;
        }

        const result = await this.remoteService.auftragAnlegen(request);

        if (!result) {
            UiHelper.showFehlerKommunikation();
            return;
        }

        if (result.ErrorMessage) {
            UiHelper.showErrorOhneSentry(result.ErrorMessage);
            return;
        }

        if (result.Success && result.Auftrag) {
            await this.auftragService.speichereAuftrag(result.Auftrag);

            this.modalController.dismiss({
                type: 'neuer-auftrag',
                auftrag: result.Auftrag
            });
        };
    }
}
